<template>
  <button class="block text-gray-800 hover:text-black z-50 cursor-pointer rounded-full bg-white h-7">
    <svg
      role="img"
      width="27"
      height="27"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="close-modal"
    ><title id="close-modal">Close</title><circle
      cx="10"
      cy="10"
      r="9.5"
      fill="rgba(255,255,255,1)"
      stroke="rgba(255,255,255,1)"
    /><path
      d="M6 6L14 14M6 14L14 6L6 14Z"
      stroke="#373F47"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    /></svg>
  </button>
</template>
